import React, { Component } from 'react';
import ClientSelectionView from './ClientSelectionView';
import queryString from 'query-string';
import { url } from '../../../Server/url/GlobalUrl';



class ClientSelectionComponent extends Component {
    state = {
        modal_show : false,
        authResponse : '',
        private : false,

    }
    hideCustomModal = () => {
        this.setState({ modal_show: false })
        if (this.state.private){
            window.location.replace('/home')
        }
    }

    showCustomModal = () => {
        this.setState({ modal_show: true })

    }
    handeldata = (identity) => {
        console.log('identity',identity)

        if (identity == 'private_individual'){
            var data = {'user' : localStorage.getItem('cv-id'), 'status' : '3'}
        }else if(identity == 'local_council'){
            var data = {'user' : localStorage.getItem('cv-id'), 'status' : '2'}
        }else if(identity == 'nursing_home'){
            var data = {'user' : localStorage.getItem('cv-id'), 'status' : '1'}
        }
        fetch(url + '/api/v1/user/employer-role-status/', {
		method: 'POST',
		headers: {
		   'Accept': 'application/json',
          'Content-Type': 'application/json',
		},
		body: JSON.stringify(data)
	    })
		.then((response) => {
            console.log("response", response)
            if (response['status'] === 201 || response['status'] === 200) {
                   if (identity == 'private_individual'){
                    this.setState({'authResponse' : 'Congrats you are now registered please go to the post a job feature to create your job.'})
                    this.setState({'private' : true})
                    this.showCustomModal()
                    }else if(identity == 'local_council'){
                        window.location.replace('/client/form1')
                    }else if(identity == 'nursing_home'){
                        window.location.replace('/client/form1')
                    }
                return response.json()
            } else if (response['status'] === 400 ) {
                    this.showCustomModal()
                    this.setState({authResponse:'Some Thing Went Wrong Please try again'})
                    return response.json()
            }
        })
		.then((result) => {
		console.log('result',result)
		})
    }

    render() {
        return (<ClientSelectionView
				authResponse = {this.state.authResponse}
				modal_show = {this.state.modal_show}
				hideCustomModal = {this.hideCustomModal}
				handeldata = {this.handeldata}
        	/>)
    }
}

export default ClientSelectionComponent;